import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import Button from '../../elements-buttons/Button';
import { FormattedMessage } from 'react-intl';

const DeleteAddOnModal = (props) => (
  <BootstrapModal
    {...props}
    modalSize="sm-size"
    modalClass="edit-add-on-modal"
    header={<h3><FormattedMessage id='inbox.delete_add_on_modal.delete_item' defaultMessage='Delete Item' /></h3>}
    body={
      <div className="text-gray-600 text-center">
        <div>
          <FormattedMessage
            id='inbox.delete_add_on_modal.sure_delete'
            defaultMessage='Are you sure you want to delete this item?'
          />
        </div>
        <div>
          <FormattedMessage
            id='inbox.delete_add_on_modal.note_deleting'
            defaultMessage="Note: Deleting items won't affect in-progress bookings."
          />
        </div>
        <hr className="no-bottom-margin" />
      </div>
    }
    footer={
      <Button
        category="danger"
        onClick={props.deleteItem}
        attributes={{ 'data-testing-id': 'delete-add-on-btn' }}
      >
        <FormattedMessage
          id='inbox.delete_add_on_modal.delete'
          defaultMessage="Delete"
        />
      </Button>
    }
  />
);

DeleteAddOnModal.propTypes = {
  deleteItem: PropTypes.func
};

export default DeleteAddOnModal;
